<template>
  <div v-if="!isXiaodu"
       class="menu">
    <div class="menu_button">
      <slot name="left-link">
        <a @click="$router.goBack()"
           href="javascript:;">
        </a>
      </slot>
      <slot name="back-home">
        <router-link class="backhome"
                     to="/"
                     v-if="home">
        </router-link>
      </slot>
    </div>
    <span class="page_name">{{title}}</span>
    <div class="menu_button right">
      <slot v-if="location"
            name="right-link">
        <div class="servicePoint">
          <span class="glyphicon glyphicon-map-marker"></span>
          <span v-html="positionName"></span>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {},
    home: {
      default: false
    },
    location: {
      default: true
    }
  },
  data () {
    return {
      positionName: '',
      isXiaodu: localStorage.getItem('xiaodu') || false
    }
  },
  methods: {
    goback () {
      this.$router.go(-1)
    }
  },
  mounted () {
    const { name, config } = this.$store.state.device.point
    if (config && JSON.parse(config).zd_skin === 'yunshangxuean') {
      this.location = false
    }
    this.positionName = name || ''
  }
}
</script>
<style lang="stylus">
.menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.2rem;
  padding: 0 0.6rem;
  z-index: 300;
  flex-shrink: 0;
  background-size: cover;
  .page_name {
    color: #fff;
    font-size: 0.44rem;
    text-align: center;
    line-height: 1.2rem;
    overflow: hidden; /* 确保超出容器的文本被隐藏 */
    white-space: nowrap; /* 防止文本换行 */
    text-overflow: ellipsis; /* 用省略号表示被截断的文本 */
  }
  .menu_button {
    display: flex;
    width: 4.5rem;
    a:first-child {
      display: block;
      position: relative;
      height: 0.6rem;
      width: 1.45rem;
      position: relative;
      margin-right: 0.3rem;
      flex-shrink: 0;
      background: url('/img/ui/bg_back.png') center center / cover no-repeat;
      &:before {
        content: '返回';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background-image: url('/img/ui/arrow.png');
        background-size: 0.28rem 0.18rem;
        background-position-y: 0.1rem;
        background-position-x: 0.3rem;
        color: rgb(255, 255, 255);
        font-size: 0.28rem;
        padding-left: 0.65rem;
        background-repeat: no-repeat;
      }
    }
    a.backhome {
      position: relative;
      margin-right: 0;
      width: 1.7rem;
      font-size: 0.26rem;
      color: #fff;
      background: url('/img/ui/bg_back_home.png') center center / cover no-repeat;
      &:before {
        content: '去首页';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background-image: url('/img/ui/back_home.png');
        background-size: 0.31rem 0.28rem;
        background-position-y: 0.05rem;
        background-position-x: 0.3rem;
        color: rgb(255, 255, 255);
        font-size: 0.28rem;
        padding-left: 0.68rem;
        background-repeat: no-repeat;
      }
      span {
        display: inline-block;
        line-height: 0.84rem;
        font-size: 0.24rem;
        color: #fff;
      }
    }
  }
  .right {
    justify-content: flex-end;
  }
  .servicePoint {
    color: #fff;
    font-size: 0.24rem;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      margin-right: 0.1rem;
    }
  }
}
@media screen and (orientation: portrait) {
  .menu .menu_button {
    width: 2.5rem;
    a {
      margin-right: 0.4rem;
      span {
        display: none;
      }
    }
  }
}
</style>
